import * as Mutations from './mutations';

let calculatingZoomTimeout = null

export default {
  updatePreviewZoom({ commit }, { offsetHeight, offsetWidth }) {
    commit(Mutations.SET_CALCULATING_ZOOM, true)

    if (calculatingZoomTimeout) {
      clearTimeout(calculatingZoomTimeout)
    }

    calculatingZoomTimeout = setTimeout(() => {
      const cardsHeight = 1039

      const availableSize = Math.min(offsetHeight, offsetWidth) * 0.8

      const zoom = parseFloat((availableSize / cardsHeight).toFixed(2))

      const previewZoom = Math.min(zoom, 1)

      commit(Mutations.SET_PREVIEW_ZOOM, previewZoom)

      commit(Mutations.SET_CALCULATING_ZOOM, false)
    }, 500)
  }
}